import { useEffect, useRef, useState } from "react";

export function useApiRequest(apiRequest, onMount = true) {
  const [loading, setLoading] = useState(onMount);
  const [response, setResponse] = useState();
  const [error, setError] = useState();
  const abortController = useRef();

  const sendRequest = async (options) => {
    const { resetData } = options || {};

    setLoading(true);
    setError(null);
    // cancel request if it's in-flight
    abortController.current?.abort();

    if (resetData) {
      setResponse();
    }

    abortController.current = new AbortController();
    const signal = abortController.current.signal;
    const controller = abortController.current;

    apiRequest()
      .then((data) => {
        if (!signal.aborted) {
          setResponse(data);
        }
      })
      .catch((error) => {
        if (!signal.aborted) {
          setError(error);
          setResponse([]);
        }
      })
      .finally(() => {
        // Only update state if this is still the active request — a newer
        // sendRequest call may have already replaced abortController.current.
        if (abortController.current === controller) {
          abortController.current = undefined;
          setLoading(false);
        }
      });
  };

  const cancelRequest = () => {
    abortController.current?.abort();
    abortController.current = undefined;
  };

  useEffect(() => {
    onMount && sendRequest();
  }, []);

  return {
    loading,
    response,
    error,
    sendRequest,
    cancelRequest,
  };
}
